import React from "react";
import axios from "axios";
import { Component } from "react";
import ReactModal from "react-modal";
import SglContext from "../SglContext";
import '../actions/manageCardsList.css'
import '../actions/myAccount.css'
import { LoadingSpinner } from "../actions/teamManagement/utilities";
var AddModal = ReactModal;

// const sgl_webservice_iphone = Sgl.sglApiUrl+'/iphonev2/addentryv2/';

const card_type_array = ["Visa", "MasterCard", "Amex", "Discover"];
const months_array = [
  {
    month_no: '01',
    month_name: 'January',
    value:'1',
  },
  {
    value:'2',
    month_no: '02',
    month_name: 'February'
  },
  {
    value:'3',
    month_no: '03',
    month_name: 'March'
  },
  {
    value:'4',
    month_no: '04',
    month_name: 'April'
  },
  {
    value:'5',
    month_no: '05',
    month_name: 'May'
  },
  {
    value:'6',
    month_no: '06',
    month_name: 'June'
  },
  {
    value:'7',
    month_no: '07',
    month_name: 'July'
  },
  {
    value:'8',
    month_no: '08',
    month_name: 'August'
  },
  {
    value:'9',
    month_no: '09',
    month_name: 'September'
  },
  {
    value:'10',
    month_no: '10',
    month_name: 'October'
  },
  {
    value:'11',
    month_no: '11',
    month_name: 'November'
  },
  {
    value:'12',
    month_no: '12',
    month_name: 'December'
  }
]

const countries_array = [
  'United States',
  'Canada',
  'Afghanistan',
  'Aland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia, Plurinational State of',
  'Bonaire, Saint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, the Democratic Republic of the',
  'Cook Islands',
  'Costa Rica',
  'C?te d\'Ivoire',
  'Croatia',
  'Cuba',
  'Cura?ao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  'Korea, Democratic People\'s Republic of',
  'Korea, Republic of',
  'Kuwait',
  'Kyrgyzstan',
  'Lao People\'s Democratic Republic',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, the former Yugoslav Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova, Republic of',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'R?union',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barth?lemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Swaziland',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan, Province of China',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of',
  'Viet Nam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe'
];

const new_card_data_initial = { 
  "sgl_id": '',
  "label": "",
  "description": '',
  "card_number": "",
  "card_lastfour": "",
  "card_exp": "",
  "card_exp_month": "",
  "card_exp_year": "",
  "type": "",
  "name_on_card": "",
  "card_first": "",
  "card_last": "",
  "address_1": "",
  "address_2": "",
  "city": "",
  "state": "",
  "zip": "",
  "phone": "",
  "country": "",
  "email": ""
};


/* ManageCards Component 
-------------------------------------------------*/
class ManageCards extends React.Component {
    get sgl_webservice_iphone() {
        return this.context.sglApiUrl + '/iphonev2/addentryv2/';
    }

    get sglNestApiUrl() {
        return this.context.nestApiUrl;
    }

    constructor(props) {
        super(props);

        // this.openSelectCardModal = this.openSelectCardModal.bind(this);
        this.closeSelectCardModal = this.closeSelectCardModal.bind(this);

        this.openAddCreditCardModal = this.openAddCreditCardModal.bind(this);
        this.closeAddCreditCardModal = this.closeAddCreditCardModal.bind(this);
        this.openConfirmRemoveCardModal = this.openConfirmRemoveCardModal.bind(this);
        this.closeConfirmRemoveCardModal = this.closeConfirmRemoveCardModal.bind(this);
        this.RemoveCard = this.RemoveCard.bind(this);
        this.addCreditCard = this.addCreditCard.bind(this);

        
        this.state = {
            // selected_payment_method: -1,
            // is_open_manage_card_modal: false,
            is_open_add_card_modal: props.is_open_add_card_modal ? props.is_open_add_card_modal : false,
            new_card_data: JSON.parse(JSON.stringify(new_card_data_initial)),
            add_card_error_msg: '',
            is_editing_card: false,
            is_open_remove_card_modal: false,
            card_to_remove: "",
            remove_card_msg: "",
            // deposit_cvv: "",
            openActionMenus: {},
            isSettingDefault: false,
            is_open_confirm_default_modal: false,
            card_to_set_default: null,
            isConfirmingDefault: false,
            isSavingCard: false,
        };
    }

    componentWillMount() {
        
    }
    /////////////// manage cards functions ////////////////////

    canModifyCards() {
        if( this.props.team_id > 0) {
            const myTeams = localStorage.getItem('userTeams');
            if (myTeams) {
                try {
                    const teams = JSON.parse(myTeams);

                    const selectedTeam = teams?.find(team => team.teamId == this.props.team_id);
                    if (selectedTeam && selectedTeam.isOwner) {
                        return true;
                    } else {
                        return false;
                    }
                } catch (err) {
                    return false;
                }
            } else {
                return true
            }
        } else {
            return true;
        }
    }

    onDepositMethodSelect(e) {
        if (e.target.value == 'ManageCards'){
          this.openSelectCardModal();
          this.setState({
            selected_payment_method: '-1',
          });
        } else {
          this.setState({
            selected_payment_method: e.target.value,
          });
          
        }
      }

    //   openSelectCardModal() {
    //     this.setState({
    //       is_open_manage_card_modal: true,
    //     });
    //   }
  
      closeSelectCardModal() {
          this.props.closeManageCardModal()
        // this.setState({
        //   is_open_manage_card_modal: false,
        // });
        
      }
  
      openAddCreditCardModal() {
        this.setState({
          is_open_add_card_modal: true,
          add_card_error_msg: '',
          new_card_data: JSON.parse(JSON.stringify(new_card_data_initial)),
          is_editing_card: false
        });
      }
  
      openEditCardModal = (card_data) => (e) => { 
        const card_exp_array = card_data.card_exp.split('/');
        card_data.card_exp_month = card_exp_array[0];
        card_data.card_exp_year = card_exp_array[1];
        card_data.card_number = 'xxxx-xxxx-xxxx-'+card_data.card_lastfour;

        // Normalize card type for display
        card_data.type = this.normalizeCardTypeForDisplay(card_data.type);

        this.setState({
          is_open_add_card_modal: true,
          add_card_error_msg: '',
          new_card_data: card_data,
          is_editing_card: true
        });
      }
  
      closeAddCreditCardModal() {
        this.props.getPaymentMethods();
        this.setState({
          is_open_add_card_modal: false,
          new_card_data: JSON.parse(JSON.stringify(new_card_data_initial))
        });
        
        if(this.props.is_open_add_card_modal){
            this.props.closeManageCardModal()
        }
      }
      openConfirmRemoveCardModal = (card_data) => (e) => { 
        this.setState({
          is_open_remove_card_modal: true,
          card_to_remove: card_data.sgl_id,
          
        });
      }
  
      closeConfirmRemoveCardModal() {
        this.setState({
            is_open_remove_card_modal: false,
            card_to_remove: "",
        });
        
      }

    openConfirmDefaultCardModal = (card_data) => {
        this.setState({
            is_open_confirm_default_modal: true,
            card_to_set_default: card_data,
        });
    }

    closeConfirmDefaultCardModal = () => {
        this.setState({
            is_open_confirm_default_modal: false,
            card_to_set_default: null,
        });
    }

    confirmSetDefaultCard = async () => {
        if (!this.state.card_to_set_default) return;
        
        this.setState({
            isConfirmingDefault: true  // Show loading
        });
        
        this.setState({ isSettingDefault: true });
        // Wait for the operation to complete
        await this.handleDefaultPaymentMethodChange(this.state.card_to_set_default);
        await this.context.getPendingUserActions()
        await this.getDefaultPaymentMethod()
        this.setState({ isSettingDefault: false });
        
        // NOW close the modal after operation completes
        this.setState({
            is_open_confirm_default_modal: false,
            card_to_set_default: null,
            isConfirmingDefault: false
        });
    }
      RemoveCard(){
        axios.get(this.sgl_webservice_iphone+'RemoveCard',{
            params : {
                fingerprint_id : this.state.card_to_remove,
                company_id: this.context.company_id
            }
        }).then(results => {
            const message = results.data.success ? 
                "Credit Card successfully removed." : 
                results.data.error;
                
            this.setState({
                is_open_remove_card_modal: false,
                card_to_remove: "",
                remove_card_msg: message
            });
            
            this.props.getPaymentMethods();
        })
    }

    normalizeCardTypeForDisplay = (type) => {
        if (!type) return '';
        
        const typeMap = {
            'master': 'MasterCard',
            'visa': 'Visa',
            'american_express': 'Amex',
            'discover': 'Discover',
            'M/C': 'MasterCard',
            'MasterCard': 'MasterCard',
            'Visa': 'Visa',
            'Amex': 'Amex',
            'Discover': 'Discover'
        };
        
        return typeMap[type] || type;
    }

    handleDefaultPaymentMethodChange = async (selectedCard) => {
        // Don't proceed if already the default
        if (this.state.defaultPaymentMethod?.fingerprint_id == selectedCard.sgl_id) {
            return;
        }

        let createActionStep = this.context.pendingUserOnboardAction?.hasPendingAction && !this.context.pendingUserOnboardAction?.defaultPaymentMethod

        // Create action step for authentication
        let authActionStep = createActionStep ? await axios.post(`${this.sglNestApiUrl}/billing/createActionStepData`, {
            action: 'Pay Method',
            data: { selectedPaymentMethod: selectedCard },
            loginId: this.context.current_user.sgl_id,
            companyId: this.context.company_id,
            desc: 'Authenticating default payment method'
        }) : null;

        try {
            // Pre-authorize the card
            let result = await axios.get(this.sgl_webservice_iphone + 'PreAuthorizeCreditCard', {
                params: {
                    secured_payment_method_fingerprint_id: selectedCard.sgl_id,
                    company_id: -1
                }
            });

            if (result?.data != '') {
                alert(result.data);
                if (authActionStep?.data?.sgl_id > 0) {
                    axios.post(`${this.sglNestApiUrl}/billing/completeActionStepData`, {
                        actionStepId: authActionStep?.data?.sgl_id,
                        status: 'Failure',
                        desc: `Payment method ${selectedCard.name_on_card} xxxx-${selectedCard.card_lastfour} authentication failed`,
                        error: result.data
                    });
                }
            
                return;
            }

            console.log("Validating payment method message:", result);
        } catch (err) {
            console.error("Error validating payment method:", err);
            alert('Error validating payment method: ' + err.message);
            if (authActionStep?.data?.sgl_id > 0) {
                axios.post(`${this.sglNestApiUrl}/billing/completeActionStepData`, {
                    actionStepId: authActionStep?.data?.sgl_id,
                    status: 'Failure',
                    desc: `Payment method ${selectedCard.name_on_card} xxxx-${selectedCard.card_lastfour} authentication failed`,
                    error: err.message
                });
            }
            
            return;
        }

        // Log successful authentication
        if (authActionStep?.data?.sgl_id > 0) {
            axios.post(`${this.sglNestApiUrl}/billing/completeActionStepData`, {
                actionStepId: authActionStep?.data?.sgl_id,
                status: 'Complete',
                desc: `Default payment method ${selectedCard.name_on_card} xxxx-${selectedCard.card_lastfour} authenticated successfully`,
                error: ''
            });
        }

        // Create action step for setting default
        let respActionStep = createActionStep ? await axios.post(`${this.sglNestApiUrl}/billing/createActionStepData`, {
            action: 'Pay Method',
            data: { selectedPaymentMethod: selectedCard },
            loginId: this.context.current_user.sgl_id,
            companyId: this.context.company_id,
            desc: 'Setting default payment method'
        }) : null;

        // Update default payment method
        await axios.post(`${this.sglNestApiUrl}/billing/updateDefaultCreditCard`, {
            user_id: this.context.current_user.sgl_id,
            payment_method_id: selectedCard.sgl_id,
            company_id: this.context.company_id
        }).then(async (res) => {
            if (res.data.success) {
                this.setState({ 
                    defaultPaymentMethodId: selectedCard.sgl_id,
                    isSettingDefault: false 
                });

                if (respActionStep?.data?.sgl_id > 0) {
                    axios.post(`${this.sglNestApiUrl}/billing/completeActionStepData`, {
                        actionStepId: respActionStep?.data?.sgl_id,
                        status: 'Complete',
                        desc: `Default payment method ${selectedCard.name_on_card} xxxx-${selectedCard.card_lastfour} set successfully`,
                        error: ''
                    });
                }

                // Refresh payment methods to update parent
                this.props.getPaymentMethods();
            } else {
                alert(res.data.error);
                if (respActionStep?.data?.sgl_id > 0) {
                    axios.post(`${this.sglNestApiUrl}/billing/completeActionStepData`, {
                        actionStepId: respActionStep?.data?.sgl_id,
                        status: 'Failure',
                        desc: `Failed to set default payment method ${selectedCard.name_on_card} xxxx-${selectedCard.card_lastfour}.`,
                        error: res.data.error

                    });
                }
            }
        });
    }

      updateNewCardData(evt, field) {
        var card_data = this.state.new_card_data;
        card_data[field] = evt.target.value;
  
        this.setState({
          new_card_data: card_data
        });
      }
  
      addCreditCard() {
        this.setState({ isSavingCard: true });
        var error_msg = '';
        
        // if (this.state.new_card_data.description == '') {
        //   error_msg = 'Please enter Description';
        // } else 
        if (this.state.new_card_data.card_number == ''){
          error_msg = 'Please enter Card Number';
        } else if(this.state.new_card_data.type == '') {
          error_msg = 'Please enter Credit type';
        } else if(this.state.new_card_data.card_exp_month == '') {
          error_msg = 'Please enter Expiration Month';
        } else if(this.state.new_card_data.card_exp_year == '') {
          error_msg = 'Please enter Expiration Year';
        } else if(this.state.new_card_data.name_on_card == '') {
          error_msg = 'Please enter Name on Card';
        } else if(this.props.check_card_email_phone_info && this.state.new_card_data.email == '') {
            error_msg = 'Please enter your Email Address';
        } else if(this.props.check_card_email_phone_info && this.state.new_card_data.phone == '') {
            error_msg = 'Please enter your Phone Number';
        } else if(this.props.check_address_info && this.state.new_card_data.address_1 == '') {
            error_msg = 'Please enter your Address';
        } else if(this.props.check_address_info && this.state.new_card_data.city == '') {
            error_msg = 'Please enter your City';
        } else if(this.props.check_address_info && this.state.new_card_data.state == '') {
            error_msg = 'Please enter your State';
        } else if(this.props.check_address_info && this.state.new_card_data.zip == '') {
            error_msg = 'Please enter your Zip Code';
        } else if(this.props.check_address_info && this.state.new_card_data.country == '') {
            error_msg = 'Please enter your Country';
        } else if(!this.state.new_card_data.store_card_agree){
            error_msg = 'Please select the checkbox.';
        }
  
        var card_data = this.state.new_card_data;
          
        card_data.card_exp = card_data.card_exp_month+'/'+card_data.card_exp_year;
        if (card_data.card_lastfour == ''){
          card_data.card_lastfour = card_data.card_number.substr(card_data.card_number.length - 4);
        }
        if (card_data.label == ''){
          card_data.label = 'xxxx-'+card_data.card_lastfour+' ['+card_data.type+'] ' + card_data.name_on_card;
        }
        if (error_msg == ''){
          var encoded_data = btoa(JSON.stringify(this.state.new_card_data));
          this.SaveCreditCard(encoded_data);
  
          // document.getElementById('add_people_warning').style.display = "none";
          // this.setState({is_open_people_modal: false, add_people_error_msg: ''}); 
        } else {
            this.setState({
                add_card_error_msg: error_msg,
                isSavingCard: false  
            }); 
 
          document.getElementById('add_card_warning').style.display = "block";
        }
        
      }
  
      async handleSaveCreditCardData(response_data){
        if(response_data.error){
        this.setState({
            add_card_error_msg: response_data.error,
            isSavingCard: false 
        }); 
        document.getElementById('add_card_warning').style.display = "block";
  
        } else {

            if(['Platform Fee Setup', 'Default Payment Method'].includes(this.props.calledFor) && !this.state.is_editing_card){
                // log Add credi card
                let respActionStep = await axios.post(`${this.sglNestApiUrl}/billing/createActionStepData`, {
                    action: 'Pay Method',
                    data: {},
                    loginId: this.context.current_user.sgl_id,
                    companyId: this.context.company_id,
                    desc: 'New Payment Method Added'
                })

                if(respActionStep?.data?.sgl_id > 0){
                    await axios.post(`${this.sglNestApiUrl}/billing/completeActionStepData`, {
                        actionStepId: respActionStep?.data?.sgl_id,
                        status: 'Complete',
                        desc: `New Payment Method ${this.state.new_card_data?.name_on_card} xxxx-${this.state.new_card_data?.card_lastfour} added successfully`,
                        error: ''
                    })
                }
            }
            
            // default payment method is updated
            if(
                response_data.paymentMethod && this.state.defaultPaymentMethod &&
                this.state.new_card_data.sgl_id == this.state.defaultPaymentMethod?.fingerprint_id &&
                this.state.defaultPaymentMethod?.fingerprint_id != response_data.paymentMethod?.fingerprint_id
            ){
                await axios.post(`${this.sglNestApiUrl}/billing/updateDefaultCreditCard`, {
                    user_id: this.context.current_user.sgl_id,
                    payment_method_id: response_data.paymentMethod?.fingerprint_id,
                    company_id: this.context.company_id
                })

                this.setState({defaultPaymentMethod: response_data.paymentMethod})
            }

            this.props.getPaymentMethods();

            const newCardId = response_data.paymentMethod?.fingerprint_id; 

            if(this.props.is_open_add_card_modal){
                this.props.closeManageCardModal(newCardId)
            }
          
          // this.setState(prevState => ({
          //   payment_methods: [...prevState.payment_methods, this.state.new_card_data],
          // }))
        // }
        
          document.getElementById('add_card_warning').style.display = "none";
          this.setState({
            is_open_add_card_modal: false, 
            add_card_error_msg: '',
            isSavingCard: false  
          });
  
        }
      }

      async SaveCreditCard(card_data){
        axios.get(this.sgl_webservice_iphone+'SaveCreditCard',{
          params : {
              card_data : card_data,
              company_id: this.context.company_id,
              team_id: this.props.team_id
          }
        }).then(async results => {
          await this.handleSaveCreditCardData(results.data);
           
        }).catch(error => console.log(error))
      }
  
      getExpYearsArray(){
        var years_array = [];
        var now = new Date().getFullYear()-1;
        const years = Array(now - (now - 20)).fill('').map((v, idx) => now + idx);
        years.forEach(year => {
          years_array.push({
            year_name: year,
            year_value: year
          })
        });
        return years_array;
      }
    /////////////// end manage cards functions ////////////////////
        


      format_currancy(amount){
        if(amount == 0){
          return '$0.00';
        }
        if(amount == undefined || amount == ''){
          return '';
        }
        // return '$'+(amount && amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        return '$'+(amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  
      }

    renderActionsMenu = (cardData) => {
        const menuId = `actions-${cardData.sgl_id}`;
        const isOpen = this.state.openActionMenus[menuId];
        const isDefaultCard = this.state.defaultPaymentMethod?.fingerprint_id == cardData.sgl_id;
    
        if (!this.canModifyCards()) {
            return null; 
        }
        
        return (
            <div className="actions-menu-container manage-credit-cards-modal">
                <button className="actions-trigger" onClick={() => this.toggleActionMenu(menuId)} >
                    <i className="fas fa-ellipsis-v"></i>
                </button>
                {isOpen && (
                    <div className={`actions-dropdown ${isOpen ? 'open' : ''}`}>
                            <button onClick={this.openEditCardModal(cardData)}>
                                Edit Card
                            </button>
                       
                            {
                                isDefaultCard ? null :
                                <button 
                                    className="danger" 
                                    onClick={this.openConfirmRemoveCardModal(cardData)}
                                >
                                    Remove Card
                                </button>
                            }
                    </div>
                )}
            </div>
        );
    };

        toggleActionMenu = (menuId) => {
            this.setState(prevState => ({
                openActionMenus: {
                    [menuId]: !prevState.openActionMenus[menuId]
                }
            }));
        };

        componentDidMount() {
            this.getDefaultPaymentMethod()
            document.addEventListener('click', this.handleClickOutside);
        }


        componentWillUnmount() {
            document.removeEventListener('click', this.handleClickOutside);
        }

        handleClickOutside = (event) => {
            if (!event.target.closest('.actions-menu-container')) {
                this.setState({ openActionMenus: {} });
            }
        };

    async getDefaultPaymentMethod() {
        let res = await axios.get(this.context.nestApiUrl + '/billing/getAccountPaymentMethod', {
            params: {
                user_id: this.context.current_user?.sgl_id,
                company_id: this.context.company_id
            }
        })

        this.setState({defaultPaymentMethod: res.data})
    }

    render() {
        
        return (
            <div>
                <div className="manage-cards-modal">
                    <AddModal
                        isOpen={this.props.is_open_manage_card_modal}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeSelectCardModal}
                        className="cards-modal-content manage-credit-cards-modal"
                        overlayClassName="cards-modal-overlay"
                        ariaHideApp={false}
                    >
                        <div className="cards-modal-container">
                            {/* Header */}
                            <div className="cards-modal-header">
                                <h2 className="cards-modal-title">Manage Credit Cards</h2>
                                <button className="cards-modal-close" onClick={this.closeSelectCardModal}>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                    </svg>
                                </button>
                            </div>
                            {/* Scrollable Body */}
                            <div className="cards-modal-body">
                                <div className="cards-table-wrapper">
                                    <table className="cards-table">
                                        <thead className="cards-table-head">
                                            <tr>
                                                <th className="cards-th cards-desktop-only">Card Number</th>
                                                <th className="cards-th cards-desktop-only">Name on Card</th>
                                                <th className="cards-th cards-desktop-only">Type</th>
                                                <th className="cards-th cards-desktop-only">Expiration</th>
                                                <th className="cards-th cards-desktop-only">Actions</th>
                                                <th className="cards-th cards-mobile-only">Card Details</th>
                                            </tr>
                                        </thead>
                                        <tbody className="cards-table-body">
                                            {this.props.payment_methods.map((data, index) => (
                                                <tr key={index} className="cards-table-row"
                                                >
                                                    {/* Mobile Card View */}
                                                    <td className="cards-td cards-mobile-only">
                                                        <div     
                                                        className={`cards-mobile-card ${this.state.defaultPaymentMethod?.fingerprint_id == data.sgl_id ? 'selected-default' : ''}`}
                                                        onClick={() => this.openConfirmDefaultCardModal(data)}
                                                        style={{ cursor: this.state.isSettingDefault ? 'not-allowed' : 'pointer' }}
                                                        >
                                                            {/* Actions dropdown or default badge */}
                                                            <div className="actions-dropdown-position">
                                                                {this.state.defaultPaymentMethod?.fingerprint_id === data.sgl_id ? (
                                                                    <span className="default-badge mobile">Default</span>
                                                                ) : (
                                                                    this.renderActionsMenu(data)
                                                                )}
                                                            </div>
                                                            
                                                            {/* Card fields */}
                                                            <div className="trow">
                                                                <strong>Card Number:</strong>
                                                                <div className="trow-content card-number">
                                                                    xxxx-{data.card_lastfour}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="trow">
                                                                <strong>Name on Card:</strong>
                                                                <div className="trow-content">{data.name_on_card}</div>
                                                            </div>
                                                            
                                                            <div className="trow">
                                                                <strong>Type:</strong>
                                                                <div className="trow-content">{data.type}</div>
                                                            </div>
                                                            
                                                            <div className="trow">
                                                                <strong>Expiration:</strong>
                                                                <div className="trow-content">{data.card_exp}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    {/* Desktop View */}
                                                    <td className="cards-td cards-desktop-only">
                                                            <span className="cards-card-number">xxxx-{data.card_lastfour}</span>
                                                    </td>
                                                    <td className="cards-td cards-desktop-only">
                                                        <span className="cards-name">{data.name_on_card}</span>
                                                    </td>
                                                    <td className="cards-td cards-desktop-only">
                                                        <span className="cards-type">{data.type}</span>
                                                    </td>
                                                    <td className="cards-td cards-desktop-only">
                                                        <span className="cards-expiry">{data.card_exp}</span>
                                                    </td>
                                                    <td className="cards-td cards-desktop-only">
                                                        {this.renderActionsMenu(data)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Fixed Footer */}
                            <div className="cards-modal-footer">
                                {this.state.remove_card_msg && (
                                    <div className="cards-footer-message">
                                        <p 
                                            id="remove_card_warning"
                                            className={this.state.remove_card_msg.includes('successfully') ? 'success-message' : ''}
                                            style={{ display: this.state.remove_card_msg ? 'block' : 'none' }}
                                        >
                                            {this.state.remove_card_msg}
                                        </p>
                                    </div>
                                )}
                                <button className="cards-btn cards-btn-primary" onClick={this.openAddCreditCardModal}>
                                    Add Another Card
                                </button>
                                <button className="cards-btn cards-btn-cancel" onClick={this.closeSelectCardModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    </AddModal>
                </div>

                <div>
                    <AddModal
                        isOpen={this.state.is_open_add_card_modal}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeAddCreditCardModal}
                        className="add-credit-card-modal-content"
                        overlayClassName="add-credit-card-modal-overlay"
                        ariaHideApp={false}
                    >
                        <div className="add-credit-card-modal-container">
                            {/* Header */}
                            <div className="add-credit-card-modal-header">
                                <h2 className="add-credit-card-modal-title">
                                    {this.state.is_editing_card ? 'Edit Credit Card' : 'Add Credit Card'}
                                </h2>
                                <button className="add-credit-card-modal-close" onClick={this.closeAddCreditCardModal}>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                    </svg>
                                </button>
                            </div>

                            {/* Body */}
                            <div className="add-credit-card-modal-body">
                                {/* Error Message */}
                                <div 
                                    id='add_card_warning' 
                                    className={`add-credit-card-modal-error-message ${this.state.add_card_error_msg ? '' : 'add-credit-card-modal-display-none'}`}
                                    dangerouslySetInnerHTML={{ __html: this.state.add_card_error_msg }}
                                ></div>
                                <form>
                                    {/* Card Information Section */}
                                    <div className="add-credit-card-modal-form-section">
                                        <div className="add-credit-card-modal-section-title">Card Information</div>
                                        
                                        <div className="add-credit-card-modal-form-group">
                                            <label className="add-credit-card-modal-label">
                                                Description (Displayed at checkout)
                                            </label>
                                            <input 
                                                type="text" 
                                                name="description" 
                                                className="add-credit-card-modal-modern-input" 
                                                id='txt_add_people_description' 
                                                value={this.state.new_card_data.description || this.state.new_card_data.name_on_card} 
                                                onChange={evt => this.updateNewCardData(evt, 'description')}
                                            />
                                        </div>

                                        <div className="add-credit-card-modal-form-row">
                                            <div className="add-credit-card-modal-form-group">
                                                <label className="add-credit-card-modal-label">
                                                    Credit Card Number <span className="add-credit-card-modal-required">*</span>
                                                </label>
                                                <input 
                                                    type="text" 
                                                    name="card_number" 
                                                    id='txt_add_card_number' 
                                                    className="add-credit-card-modal-modern-input"  
                                                    value={this.state.new_card_data.card_number} 
                                                    onChange={evt => this.updateNewCardData(evt, 'card_number')}
                                                />
                                            </div>
                                            <div className="add-credit-card-modal-form-group">
                                                <label className="add-credit-card-modal-label">
                                                    Credit Type <span className="add-credit-card-modal-required">*</span>
                                                </label>
                                                <select 
                                                    className="add-credit-card-modal-modern-select"  
                                                    value={this.normalizeCardTypeForDisplay(this.state.new_card_data.type)} 
                                                        onChange={(e) => {
                                                            this.updateNewCardData(e, 'type');
                                                        }}
                                                >
                                                    <option value="-1">Select...</option>
                                                    {card_type_array.map((type, index) => (
                                                        <option key={index} value={type}>
                                                            {type}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="add-credit-card-modal-form-row">
                                            <div className="add-credit-card-modal-form-group">
                                                <label className="add-credit-card-modal-label">
                                                    Expiration Month <span className="add-credit-card-modal-required">*</span>
                                                </label>
                                                <select 
                                                    className="add-credit-card-modal-modern-select"  
                                                    value={this.state.new_card_data.card_exp_month} 
                                                    onChange={(e) => this.updateNewCardData(e, 'card_exp_month')}
                                                >
                                                    <option value="-1">Select...</option>
                                                    {months_array.map((month, index) => (
                                                        <option key={index} value={`${month.value}`}>
                                                            {month.month_no} - {month.month_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="add-credit-card-modal-form-group">
                                                <label className="add-credit-card-modal-label">
                                                    Expiration Year <span className="add-credit-card-modal-required">*</span>
                                                </label>
                                                <select 
                                                    className="add-credit-card-modal-modern-select" 
                                                    value={this.state.new_card_data.card_exp_year} 
                                                    onChange={(e) => this.updateNewCardData(e, 'card_exp_year')}
                                                >
                                                    <option value="-1">Select...</option>
                                                    {this.getExpYearsArray().map((type, index) => (
                                                        <option key={index} value={`${type.year_value}`}>
                                                            {type.year_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="add-credit-card-modal-form-group">
                                            <label className="add-credit-card-modal-label">
                                                Name on Card <span className="add-credit-card-modal-required">*</span>
                                            </label>
                                            <input 
                                                type="text" 
                                                name="name_on_card" 
                                                id='txt_add_card_name' 
                                                className="add-credit-card-modal-modern-input" 
                                                value={this.state.new_card_data.name_on_card}  
                                                onChange={evt => this.updateNewCardData(evt, 'name_on_card')}
                                            />
                                        </div>
                                    </div>

                                    {/* Contact Information Section */}
                                    <div className="add-credit-card-modal-form-section">
                                        <div className="add-credit-card-modal-section-title">Contact Information</div>
                                        
                                        <div className="add-credit-card-modal-form-group">
                                            <label className="add-credit-card-modal-label">
                                                Email Address {this.props.check_card_email_phone_info ? <span className="add-credit-card-modal-required">*</span> : ''}
                                            </label>
                                            <input  
                                                type="text" 
                                                name="email" 
                                                id="txt_add_card_email" 
                                                className="add-credit-card-modal-modern-input" 
                                                value={this.state.new_card_data.email} 
                                                onChange={evt => this.updateNewCardData(evt, 'email')}
                                            />
                                        </div>

                                        <div className="add-credit-card-modal-form-group">
                                            <label className="add-credit-card-modal-label">
                                                Phone Number {this.props.check_card_email_phone_info ? <span className="add-credit-card-modal-required">*</span> : ''}
                                            </label>
                                            <input  
                                                type="text" 
                                                name="phone_number" 
                                                id="txt_add_card_phone_number" 
                                                className="add-credit-card-modal-modern-input" 
                                                value={this.state.new_card_data.phone} 
                                                onChange={evt => this.updateNewCardData(evt, 'phone')}
                                            />
                                        </div>
                                    </div>

                                    {/* Billing Address Section */}
                                    <div className="add-credit-card-modal-form-section">
                                        <div className="add-credit-card-modal-section-title">Billing Address</div>
                                        
                                        <div className="add-credit-card-modal-form-group">
                                            <label className="add-credit-card-modal-label">
                                                Address Line 1 {this.props.check_address_info ? <span className="add-credit-card-modal-required">*</span> : ''}
                                            </label>
                                            <input 
                                                type="text" 
                                                name="address1" 
                                                className="add-credit-card-modal-modern-input" 
                                                id='txt_add_card_address1' 
                                                value={this.state.new_card_data.address_1} 
                                                onChange={evt => this.updateNewCardData(evt, 'address_1')}
                                            />
                                        </div>

                                        <div className="add-credit-card-modal-form-group">
                                            <label className="add-credit-card-modal-label">Address Line 2</label>
                                            <input 
                                                type="text" 
                                                name="address2" 
                                                className="add-credit-card-modal-modern-input" 
                                                id='txt_add_card_address2' 
                                                value={this.state.new_card_data.address_2} 
                                                onChange={evt => this.updateNewCardData(evt, 'address_2')}
                                            />
                                        </div>

                                        <div className="add-credit-card-modal-form-row">
                                            <div className="add-credit-card-modal-form-group">
                                                <label className="add-credit-card-modal-label">
                                                    City {this.props.check_address_info ? <span className="add-credit-card-modal-required">*</span> : ''}
                                                </label>
                                                <input 
                                                    type="text" 
                                                    name="city" 
                                                    id='txt_add_card_city' 
                                                    className="add-credit-card-modal-modern-input" 
                                                    value={this.state.new_card_data.city}  
                                                    onChange={evt => this.updateNewCardData(evt, 'city')}
                                                />
                                            </div>
                                            <div className="add-credit-card-modal-form-group">
                                                <label className="add-credit-card-modal-label">
                                                    State {this.props.check_address_info ? <span className="add-credit-card-modal-required">*</span> : ''}
                                                </label>
                                                <select 
                                                    className="add-credit-card-modal-modern-select"  
                                                    value={this.state.new_card_data.state} 
                                                    onChange={(e) => this.updateNewCardData(e, 'state')}
                                                >
                                                    <option value="-1">Select your state/province</option>
                                                    <option value="--">Outside U.S./Canada</option>
                                                    <optgroup label="Canada">
                                                        <option value="AB">Alberta</option>
                                                        <option value="BC">British Columbia</option>
                                                        <option value="MB">Manitoba</option>
                                                        <option value="NB">New Brunswick</option>
                                                        <option value="NL">Newfoundland and Labrador</option>
                                                        <option value="NT">Northwest Territories</option>
                                                        <option value="NS">Nova Scotia</option>
                                                        <option value="NU">Nunavut</option>
                                                        <option value="ON">Ontario</option>
                                                        <option value="PE">Prince Edward Island</option>
                                                        <option value="QC">Quebec</option>
                                                        <option value="SK">Saskatchewan</option>
                                                        <option value="YT">Yukon</option>
                                                    </optgroup>
                                                    <optgroup label="United States">
                                                        <option value="AL">Alabama</option>
                                                        <option value="AK">Alaska</option>
                                                        <option value="AS">American Samoa</option>
                                                        <option value="AZ">Arizona</option>
                                                        <option value="AR">Arkansas</option>
                                                        <option value="AA">Armed Forces Americas</option>
                                                        <option value="AE">Armed Forces Europe</option>
                                                        <option value="AP">Armed Forces Pacific</option>
                                                        <option value="CA">California</option>
                                                        <option value="CO">Colorado</option>
                                                        <option value="CT">Connecticut</option>
                                                        <option value="DE">Delaware</option>
                                                        <option value="DC">District of Columbia</option>
                                                        <option value="FL">Florida</option>
                                                        <option value="GA">Georgia</option>
                                                        <option value="GU">Guam</option>
                                                        <option value="HI">Hawaii</option>
                                                        <option value="ID">Idaho</option>
                                                        <option value="IL">Illinois</option>
                                                        <option value="IN">Indiana</option>
                                                        <option value="IA">Iowa</option>
                                                        <option value="KS">Kansas</option>
                                                        <option value="KY">Kentucky</option>
                                                        <option value="LA">Louisiana</option>
                                                        <option value="ME">Maine</option>
                                                        <option value="MD">Maryland</option>
                                                        <option value="MA">Massachusetts</option>
                                                        <option value="MI">Michigan</option>
                                                        <option value="MN">Minnesota</option>
                                                        <option value="MS">Mississippi</option>
                                                        <option value="MO">Missouri</option>
                                                        <option value="MT">Montana</option>
                                                        <option value="NE">Nebraska</option>
                                                        <option value="NV">Nevada</option>
                                                        <option value="NH">New Hampshire</option>
                                                        <option value="NJ">New Jersey</option>
                                                        <option value="NM">New Mexico</option>
                                                        <option value="NY">New York</option>
                                                        <option value="NC">North Carolina</option>
                                                        <option value="ND">North Dakota</option>
                                                        <option value="MP">Northern Marianas</option>
                                                        <option value="OH">Ohio</option>
                                                        <option value="OK">Oklahoma</option>
                                                        <option value="OR">Oregon</option>
                                                        <option value="PW">Palau</option>
                                                        <option value="PA">Pennsylvania</option>
                                                        <option value="PR">Puerto Rico</option>
                                                        <option value="RI">Rhode Island</option>
                                                        <option value="SC">South Carolina</option>
                                                        <option value="SD">South Dakota</option>
                                                        <option value="TN">Tennessee</option>
                                                        <option value="TX">Texas</option>
                                                        <option value="UT">Utah</option>
                                                        <option value="VT">Vermont</option>
                                                        <option value="VI">Virgin Islands</option>
                                                        <option value="VA">Virginia</option>
                                                        <option value="WA">Washington</option>
                                                        <option value="WV">West Virginia</option>
                                                        <option value="WI">Wisconsin</option>
                                                        <option value="WY">Wyoming</option>
                                                    </optgroup>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="add-credit-card-modal-form-row">
                                            <div className="add-credit-card-modal-form-group">
                                                <label className="add-credit-card-modal-label">
                                                    Zip Code {this.props.check_address_info ? <span className="add-credit-card-modal-required">*</span> : ''}
                                                </label>
                                                <input 
                                                    type="text" 
                                                    name="zip_code" 
                                                    id='txt_add_card_zip_code' 
                                                    className="add-credit-card-modal-modern-input"  
                                                    value={this.state.new_card_data.zip} 
                                                    onChange={evt => this.updateNewCardData(evt, 'zip')}
                                                />
                                            </div>
                                            <div className="add-credit-card-modal-form-group">
                                                <label className="add-credit-card-modal-label">
                                                    Country {this.props.check_address_info ? <span className="add-credit-card-modal-required">*</span> : ''}
                                                </label>
                                                <select 
                                                    className="add-credit-card-modal-modern-select"  
                                                    value={this.state.new_card_data.country} 
                                                    onChange={(e) => this.updateNewCardData(e, 'country')}
                                                >
                                                    <option value="-1">Select...</option>
                                                    <option value="AF">Afghanistan</option>
                                                    <option value="AX">Åland Islands</option>
                                                    <option value="AL">Albania</option>
                                                    <option value="DZ">Algeria</option>
                                                    <option value="AS">American Samoa</option>
                                                    <option value="AD">Andorra</option>
                                                    <option value="AO">Angola</option>
                                                    <option value="AI">Anguilla</option>
                                                    <option value="AQ">Antarctica</option>
                                                    <option value="AG">Antigua and Barbuda</option>
                                                    <option value="AR">Argentina</option>
                                                    <option value="AM">Armenia</option>
                                                    <option value="AW">Aruba</option>
                                                    <option value="AU">Australia</option>
                                                    <option value="AT">Austria</option>
                                                    <option value="AZ">Azerbaijan</option>
                                                    <option value="BS">Bahamas</option>
                                                    <option value="BH">Bahrain</option>
                                                    <option value="BD">Bangladesh</option>
                                                    <option value="BB">Barbados</option>
                                                    <option value="BY">Belarus</option>
                                                    <option value="BE">Belgium</option>
                                                    <option value="BZ">Belize</option>
                                                    <option value="BJ">Benin</option>
                                                    <option value="BM">Bermuda</option>
                                                    <option value="BT">Bhutan</option>
                                                    <option value="BO">Bolivia</option>
                                                    <option value="BA">Bosnia and Herzegovina</option>
                                                    <option value="BW">Botswana</option>
                                                    <option value="BV">Bouvet Island</option>
                                                    <option value="BR">Brazil</option>
                                                    <option value="IO">British Indian Ocean Territory</option>
                                                    <option value="BN">Brunei Darussalam</option>
                                                    <option value="BG">Bulgaria</option>
                                                    <option value="BF">Burkina Faso</option>
                                                    <option value="BI">Burundi</option>
                                                    <option value="KH">Cambodia</option>
                                                    <option value="CM">Cameroon</option>
                                                    <option value="CA">Canada</option>
                                                    <option value="CV">Cape Verde</option>
                                                    <option value="KY">Cayman Islands</option>
                                                    <option value="CF">Central African Republic</option>
                                                    <option value="TD">Chad</option>
                                                    <option value="CL">Chile</option>
                                                    <option value="CN">China</option>
                                                    <option value="CX">Christmas Island</option>
                                                    <option value="CC">Cocos (Keeling) Islands</option>
                                                    <option value="CO">Colombia</option>
                                                    <option value="KM">Comoros</option>
                                                    <option value="CG">Congo</option>
                                                    <option value="CD">Congo, The Democratic Republic of the</option>
                                                    <option value="CK">Cook Islands</option>
                                                    <option value="CR">Costa Rica</option>
                                                    <option value="CI">Côte D'ivoire</option>
                                                    <option value="HR">Croatia</option>
                                                    <option value="CU">Cuba</option>
                                                    <option value="CY">Cyprus</option>
                                                    <option value="CZ">Czech Republic</option>
                                                    <option value="DK">Denmark</option>
                                                    <option value="DJ">Djibouti</option>
                                                    <option value="DM">Dominica</option>
                                                    <option value="DO">Dominican Republic</option>
                                                    <option value="EC">Ecuador</option>
                                                    <option value="EG">Egypt</option>
                                                    <option value="SV">El Salvador</option>
                                                    <option value="GQ">Equatorial Guinea</option>
                                                    <option value="ER">Eritrea</option>
                                                    <option value="EE">Estonia</option>
                                                    <option value="ET">Ethiopia</option>
                                                    <option value="FK">Falkland Islands (Malvinas)</option>
                                                    <option value="FO">Faroe Islands</option>
                                                    <option value="FJ">Fiji</option>
                                                    <option value="FI">Finland</option>
                                                    <option value="FR">France</option>
                                                    <option value="GF">French Guiana</option>
                                                    <option value="PF">French Polynesia</option>
                                                    <option value="TF">French Southern Territories</option>
                                                    <option value="GA">Gabon</option>
                                                    <option value="GM">Gambia</option>
                                                    <option value="GE">Georgia</option>
                                                    <option value="DE">Germany</option>
                                                    <option value="GH">Ghana</option>
                                                    <option value="GI">Gibraltar</option>
                                                    <option value="GR">Greece</option>
                                                    <option value="GL">Greenland</option>
                                                    <option value="GD">Grenada</option>
                                                    <option value="GP">Guadeloupe</option>
                                                    <option value="GU">Guam</option>
                                                    <option value="GT">Guatemala</option>
                                                    <option value="GG">Guernsey</option>
                                                    <option value="GN">Guinea</option>
                                                    <option value="GW">Guinea-Bissau</option>
                                                    <option value="GY">Guyana</option>
                                                    <option value="HT">Haiti</option>
                                                    <option value="HM">Heard Island and McDonald Islands</option>
                                                    <option value="VA">Holy See (Vatican City state)</option>
                                                    <option value="HN">Honduras</option>
                                                    <option value="HK">Hong Kong</option>
                                                    <option value="HU">Hungary</option>
                                                    <option value="IS">Iceland</option>
                                                    <option value="IN">India</option>
                                                    <option value="ID">Indonesia</option>
                                                    <option value="IR">Iran, Islamic Republic of</option>
                                                    <option value="IQ">Iraq</option>
                                                    <option value="IE">Ireland</option>
                                                    <option value="IM">Isle Of Man</option>
                                                    <option value="IL">Israel</option>
                                                    <option value="IT">Italy</option>
                                                    <option value="JM">Jamaica</option>
                                                    <option value="JP">Japan</option>
                                                    <option value="JE">Jersey</option>
                                                    <option value="JO">Jordan</option>
                                                    <option value="KZ">Kazakhstan</option>
                                                    <option value="KE">Kenya</option>
                                                    <option value="KI">Kiribati</option>
                                                    <option value="KP">Korea, Democratic People's Republic Of</option>
                                                    <option value="KR">Korea, Republic of</option>
                                                    <option value="KW">Kuwait</option>
                                                    <option value="KG">Kyrgyzstan</option>
                                                    <option value="LA">Lao People's Democratic Republic</option>
                                                    <option value="LV">Latvia</option>
                                                    <option value="LB">Lebanon</option>
                                                    <option value="LS">Lesotho</option>
                                                    <option value="LR">Liberia</option>
                                                    <option value="LY">Libyan Arab Jamahiriya</option>
                                                    <option value="LI">Liechtenstein</option>
                                                    <option value="LT">Lithuania</option>
                                                    <option value="LU">Luxembourg</option>
                                                    <option value="MO">Macao</option>
                                                    <option value="MK">Macedonia, The Former Yugoslav Republic of</option>
                                                    <option value="MG">Madagascar</option>
                                                    <option value="MW">Malawi</option>
                                                    <option value="MY">Malaysia</option>
                                                    <option value="MV">Maldives</option>
                                                    <option value="ML">Mali</option>
                                                    <option value="MT">Malta</option>
                                                    <option value="MH">Marshall Islands</option>
                                                    <option value="MQ">Martinique</option>
                                                    <option value="MR">Mauritania</option>
                                                    <option value="MU">Mauritius</option>
                                                    <option value="YT">Mayotte</option>
                                                    <option value="MX">Mexico</option>
                                                    <option value="FM">Micronesia, Federated States of</option>
                                                    <option value="MD">Moldova, Republic of</option>
                                                    <option value="MC">Monaco</option>
                                                    <option value="MN">Mongolia</option>
                                                    <option value="ME">Montenegro</option>
                                                    <option value="MS">Montserrat</option>
                                                    <option value="MA">Morocco</option>
                                                    <option value="MZ">Mozambique</option>
                                                    <option value="MM">Myanmar</option>
                                                    <option value="NA">Namibia</option>
                                                    <option value="NR">Nauru</option>
                                                    <option value="NP">Nepal</option>
                                                    <option value="NL">Netherlands</option>
                                                    <option value="AN">Netherlands Antilles</option>
                                                    <option value="NC">New Caledonia</option>
                                                    <option value="NZ">New Zealand</option>
                                                    <option value="NI">Nicaragua</option>
                                                    <option value="NE">Niger</option>
                                                    <option value="NG">Nigeria</option>
                                                    <option value="NU">Niue</option>
                                                    <option value="NF">Norfolk Island</option>
                                                    <option value="MP">Northern Mariana Islands</option>
                                                    <option value="NO">Norway</option>
                                                    <option value="OM">Oman</option>
                                                    <option value="PK">Pakistan</option>
                                                    <option value="PW">Palau</option>
                                                    <option value="PS">Palestinian Territory, Occupied</option>
                                                    <option value="PA">Panama</option>
                                                    <option value="PG">Papua New Guinea</option>
                                                    <option value="PY">Paraguay</option>
                                                    <option value="PE">Peru</option>
                                                    <option value="PH">Philippines</option>
                                                    <option value="PN">Pitcairn</option>
                                                    <option value="PL">Poland</option>
                                                    <option value="PT">Portugal</option>
                                                    <option value="PR">Puerto Rico</option>
                                                    <option value="QA">Qatar</option>
                                                    <option value="RE">Reunion</option>
                                                    <option value="RO">Romania</option>
                                                    <option value="RU">Russian Federation</option>
                                                    <option value="RW">Rwanda</option>
                                                    <option value="BL">Saint Barthélemy</option>
                                                    <option value="SH">Saint Helena</option>
                                                    <option value="KN">Saint Kitts and Nevis</option>
                                                    <option value="LC">Saint Lucia</option>
                                                    <option value="MF">Saint Martin</option>
                                                    <option value="PM">Saint Pierre and Miquelon</option>
                                                    <option value="VC">Saint Vincent and the Grenadines</option>
                                                    <option value="WS">Samoa</option>
                                                    <option value="SM">San Marino</option>
                                                    <option value="ST">Sao Tome and Principe</option>
                                                    <option value="SA">Saudi Arabia</option>
                                                    <option value="SN">Senegal</option>
                                                    <option value="RS">Serbia</option>
                                                    <option value="CS">Serbia and Montenegro</option>
                                                    <option value="SC">Seychelles</option>
                                                    <option value="SL">Sierra Leone</option>
                                                    <option value="SG">Singapore</option>
                                                    <option value="SK">Slovakia</option>
                                                    <option value="SI">Slovenia</option>
                                                    <option value="SB">Solomon Islands</option>
                                                    <option value="SO">Somalia</option>
                                                    <option value="ZA">South Africa</option>
                                                    <option value="GS">South Georgia and the South Sandwich Islands</option>
                                                    <option value="ES">Spain</option>
                                                    <option value="LK">Sri Lanka</option>
                                                    <option value="SD">Sudan</option>
                                                    <option value="SR">Suriname</option>
                                                    <option value="SJ">Svalbard and Jan Mayen</option>
                                                    <option value="SZ">Swaziland</option>
                                                    <option value="SE">Sweden</option>
                                                    <option value="CH">Switzerland</option>
                                                    <option value="SY">Syrian Arab Republic</option>
                                                    <option value="TW">Taiwan, Province of China</option>
                                                    <option value="TJ">Tajikistan</option>
                                                    <option value="TZ">Tanzania, United Republic of</option>
                                                    <option value="TH">Thailand</option>
                                                    <option value="TL">Timor-Leste</option>
                                                    <option value="TG">Togo</option>
                                                    <option value="TK">Tokelau</option>
                                                    <option value="TO">Tonga</option>
                                                    <option value="TT">Trinidad and Tobago</option>
                                                    <option value="TN">Tunisia</option>
                                                    <option value="TR">Turkey</option>
                                                    <option value="TM">Turkmenistan</option>
                                                    <option value="TC">Turks and Caicos Islands</option>
                                                    <option value="TV">Tuvalu</option>
                                                    <option value="UG">Uganda</option>
                                                    <option value="UA">Ukraine</option>
                                                    <option value="AE">United Arab Emirates</option>
                                                    <option value="GB">United Kingdom</option>
                                                    <option value="US">United States</option>
                                                    <option value="UM">United States Minor Outlying Islands</option>
                                                    <option value="UY">Uruguay</option>
                                                    <option value="UZ">Uzbekistan</option>
                                                    <option value="VU">Vanuatu</option>
                                                    <option value="VE">Venezuela</option>
                                                    <option value="VN">Viet Nam</option>
                                                    <option value="VG">Virgin Islands, British</option>
                                                    <option value="VI">Virgin Islands, U.S.</option>
                                                    <option value="WF">Wallis and Futuna</option>
                                                    <option value="EH">Western Sahara</option>
                                                    <option value="YE">Yemen</option>
                                                    <option value="ZM">Zambia</option>
                                                    <option value="ZW">Zimbabwe</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Agreement Section */}
                                    <div className="add-credit-card-modal-agreement-section">
                                        <div className="add-credit-card-modal-checkbox-group">
                                            <input 
                                                type='checkbox' 
                                                name='store-card-agree' 
                                                id='store-card-agree' 
                                                value='1' 
                                                onChange={(e) => this.setState({
                                                    new_card_data: {
                                                        ...this.state.new_card_data, 
                                                        store_card_agree: e.target.checked 
                                                    } 
                                                })} 
                                            />
                                            <label htmlFor='store-card-agree'>
                                                I authorize ShowGrounds, LLC to store my card in a secure credit card vault for future payment processing.
                                            </label>
                                        </div>
                                    </div>
                                </form>
                            </div>

                            {/* Footer */}
                            <div className="add-credit-card-modal-footer">
                                <button type="button" className="add-credit-card-modal-btn-cancel" onClick={this.closeAddCreditCardModal}>
                                    Cancel
                                </button>
                                <button 
                                    type="button" 
                                    className="add-credit-card-modal-btn-primary" 
                                    onClick={this.addCreditCard}
                                    disabled={this.state.isSavingCard}
                                    >
                                    {this.state.isSavingCard ? (
                                        <LoadingSpinner message="" />
                                    ) : (
                                        'Save'
                                    )}
                                </button>
                            </div>
                        </div>
                    </AddModal>
                </div> 

                <AddModal
                        isOpen={this.state.is_open_remove_card_modal}
                        // onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeConfirmRemoveCardModal}
                        className="modern-team-modal remove-credit-card-modal"
                        overlayClassName="modern-team-overlay remove-credit-card-modal"
                        ariaHideApp={false}
                    >

                        <div className="modern-modal-header">
                            <h2>Remove Credit Card</h2>
                            <button className="modern-close-btn" onClick={this.closeConfirmRemoveCardModal}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            </button>
                        </div>
                        <div className="modern-modal-body">
                            {/* <h3 class='top-margin-15'>Terms and Conditions</h3> */}
                            <p className="modal-description">Are you sure you want to remove this card?</p>
                            {/* <div>
                            <p class='green-text'>Your credit card will be charged for {this.format_currancy(this.state.selected_subscription_obj.price)} (USD)</p>
                            </div>        */}
                        </div>
                        <div className="modern-modal-footer">
                            <button className="modern-btn-cancel" onClick={this.closeConfirmRemoveCardModal}>
                                Close
                            </button>
                            <button id='confirm_subscribe_button' className="modern-btn-primary" onClick={this.RemoveCard}>
                                OK
                            </button>
                        </div>
                </AddModal>

                <AddModal
                    isOpen={this.state.is_open_confirm_default_modal}
                    onRequestClose={this.closeConfirmDefaultCardModal}
                    className="modern-team-modal remove-credit-card-modal confirm-default-card-modal"
                    overlayClassName="modern-team-overlay remove-credit-card-modal"
                    ariaHideApp={false}
                >
                    <div className="modern-modal-header">
                        <h2>Set Default Payment Method</h2>
                        <button className="modern-close-btn" onClick={this.closeConfirmDefaultCardModal}>
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </button>
                    </div>
                    <div className="modern-modal-body">
                        <p className="modal-description">
                            Are you sure you want to set this card (xxxx-{this.state.card_to_set_default?.card_lastfour}) as your default payment method?
                        </p>
                    </div>
                    <div className="modern-modal-footer">
                        <button className="modern-btn-cancel" onClick={this.closeConfirmDefaultCardModal} disabled={this.state.isConfirmingDefault}>
                            Cancel
                        </button>
                        <button 
                            className="modern-btn-primary" 
                            onClick={this.confirmSetDefaultCard}
                            disabled={this.state.isConfirmingDefault}
                        >
                            {this.state.isConfirmingDefault ? (
                                <LoadingSpinner message="" />
                            ) : 'Confirm'}
                        </button>
                    </div>
                </AddModal>           
            </div>
      
        );
    }
}
ManageCards.contextType = SglContext

export default ManageCards;